import { oldPermissionsAddressRedirect } from "permissions/_views/old-permissions-addresses";
import PermissionsHomePage from "permissions/_views/home/permissions-home-page";
import { Navigate, useLocation } from "react-router";

/**
 * `/permissions`: the home page, which gates itself on Member Permissions. An address of the retired
 * query-string screens is sent on to the page that replaced it first (#6177).
 */
export default function PermissionsHomeRoute() {
  const location = useLocation();
  const movedTo = oldPermissionsAddressRedirect(location.search);
  if (movedTo) return <Navigate to={movedTo} replace />;
  return <PermissionsHomePage />;
}
